import { BasicCompanyDto } from 'dtos/companies'
import * as yup from 'yup'

export const BasicCompanyDtoValidator = (name: string) =>
  yup.object<BasicCompanyDto>({
    companyGuid: yup.string().required(`${name} is required.`)
  })
